<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip }">
      <v-badge
        color="primary"
        icon="mdi-check"
        :value="disponibile"
        overlap
        bordered
        offset-x="20"
        offset-y="20"
      >
        <v-avatar
          v-on="{ ...tooltip }"
          class="mr-2"
          size="70"
          style="cursor: pointer"
          @click="toggle_disponibile()"
        >
          <v-img :src="colore_url">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-icon>mdi-image-off</v-icon>
              </v-row>
            </template>
          </v-img>
        </v-avatar>
      </v-badge>
    </template>
    <span>{{colore.nome}}</span>
  </v-tooltip>
</template>

<script>
import colore_specie_mixin from "../../Mixin/colore_specie_mixin.js";
export default {
  mixins: [colore_specie_mixin],
};
</script>

